import { render } from "./CertificateHolderReport.vue?vue&type=template&id=39318e15&scoped=true"
import script from "./CertificateHolderReport.vue?vue&type=script&lang=js"
export * from "./CertificateHolderReport.vue?vue&type=script&lang=js"

import "./CertificateHolderReport.vue?vue&type=style&index=0&id=39318e15&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39318e15"]])

export default __exports__